// import React, { useLayoutEffect, useRef, useState, useEffect } from "react";
// import * as am5 from "@amcharts/amcharts5";
// import * as am5xy from "@amcharts/amcharts5/xy";
// import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";



// const AmCandlestickChartReact = () => {
//   const chartRef = useRef(null);
//   const wsRef = useRef(null); // to keep websocket instance
//   const [data, setData] = useState([]);
//   const websoketarrref = useRef([]);
//   const seriesRef = useRef();
//   // Format date to YYYY-MM-DD
//   const formatDate = (date) => {
//     return date.toISOString().split("T")[0];
//   };

//   // Fetch historical data once
//   useEffect(() => {
//     const fetchData = async () => {
//       const startDate = "2025-05-14";
//       const currentTimestamp = Math.floor(Date.now() / 1000) * 1000;

//       const url = `https://api.polygon.io/v2/aggs/ticker/X:BTCUSD/range/1/minute/${startDate}/${formatDate(
//         new Date()
//       )}?adjusted=true&apiKey=${API_KEY}`;

//       try {
//         const response = await fetch(url);
//         const json = await response.json();

//         if (json && json.results) {
//           const chartData = json.results.map((item) => ({
//             date: item.t, // timestamp in ms
//             open: item.o,
//             high: item.h,
//             low: item.l,
//             value: item.c, // close price
//           }));
//           setData(chartData);
//           runwebsoket(chartData);
//         }
//       } catch (error) {
//         console.error("Error fetching Polygon data:", error);
//       }
//     };

//     fetchData();
//   }, []);
//   useEffect(() => {
//     if (data.length === 0) return;
//     console.log(data, "data");
//     seriesRef.current.data.setAll(data);
//   }, [data]);
//   // Setup WebSocket connection and update chart data live
//  function updateDataWithWebSocketData(
//   initialData,
//   newData,
//   interval = 1,
//   unit = "minute"
// ) {
//   const secondsTimestamp = Math.floor(newData.date / 1000);
//   const newTimestamp = Math.floor(secondsTimestamp / (interval * 60)) * interval * 60;
//   const lastIndex = initialData.length - 1;
//   const lastCandle = initialData[lastIndex];
//   let updated = false;

//   // Create a copy of the data array for immutability
//   const updatedData = [...initialData];

//   for (let i = 0; i < updatedData.length; i++) {
//     if (updatedData[i].date === newTimestamp * 1000) {
//       websoketarrref.current.push({
//         value: newData.value,
//       });

//       const highestHigh = Math.max(
//         ...websoketarrref.current.map((item) => item.value)
//       );
//       const lowestLow = Math.min(
//         ...websoketarrref.current.map((item) => item.value)
//       );

//       updatedData[i] = {
//         ...updatedData[i],
//         value: newData.value,
//         high: highestHigh,
//         low: lowestLow,
//         date: newTimestamp * 1000,
//       };

//       updated = true;
//       break;
//     }
//   }

//   if (!updated) {
//     websoketarrref.current = [];
//     updatedData.push({
//       open: newData.value,
//       value: newData.value,
//       high: newData.value,
//       low: newData.value,
//       date: newTimestamp * 1000,
//     });
//   }

//   // Update chart series data directly
//   if (seriesRef.current) {
//     seriesRef.current.data.setAll(updatedData);
//   }

//   return updatedData;
// }
//   const runwebsoket = (data) => {
//     if (data.length === 0) return;

//     const socket = new WebSocket("wss://socket.polygon.io/crypto");
//     wsRef.current = socket;

//     socket.onopen = () => {
//       console.log("Polygon WebSocket connected");
//       socket.send(`{"action":"auth","params":"${API_KEY}"}`);
//       socket.send(`{"action":"subscribe","params":"XAS.BTC-USD@agg"}`); // subscribe to aggregate trades for BTCUSD
//     };

//     socket.onmessage = (event) => {
//       const messages = JSON.parse(event.data);
//       if (!Array.isArray(messages)) return;
//       console.log(messages, "messages");
//       messages.forEach((msg) => {
//         if (msg.ev === "XAS") {
//           // XA = Aggregate trades event
//           // Polygon sends a new trade candle aggregate update

//           const newCandle = {
//             date: msg.s,
//             open: msg.o,
//             high: msg.h,
//             low: msg.l,
//             value: msg.c,
//           };
//           let updateddata = updateDataWithWebSocketData(data, newCandle);
//           console.log(updateddata, "updateddata")
//           setData(updateddata);
//           // setData((prevData) => {
//           //   // Update existing candle if timestamp matches, else append
//           //   const lastCandle = prevData[prevData.length - 1];
//           //   if (lastCandle && lastCandle.date === newCandle.date) {
//           //     // Replace last candle
//           //     return [...prevData.slice(0, -1), newCandle];
//           //   } else {
//           //     return [...prevData, newCandle];
//           //   }
//           // });
//         }
//       });
//     };

//     socket.onerror = (err) => {
//       console.error("WebSocket error:", err);
//     };

//     socket.onclose = () => {
//       console.log("Polygon WebSocket disconnected");
//     };

//     return () => {
//       socket.close();
//     };
//   };

//   // Render chart with amCharts
//   useEffect(() => {
//     // if (data.length === 0) return;

//     const root = am5.Root.new(chartRef.current);
//     root.setThemes([am5themes_Animated.new(root)]);

//     const chart = root.container.children.push(
//       am5xy.XYChart.new(root, {
//         focusable: true,
//         panX: true,
//         panY: true,
//         wheelX: "panX",
//         wheelY: "zoomX",
//         paddingRight: 40,
//       })
//     );

//     const xAxis = chart.xAxes.push(
//       am5xy.DateAxis.new(root, {
//         baseInterval: { timeUnit: "minute", count: 1 },
//         renderer: am5xy.AxisRendererX.new(root, {
//           minGridDistance: 50,
//         }),
//         tooltip: am5.Tooltip.new(root, {}),
//       })
//     );

//     const yAxis = chart.yAxes.push(
//       am5xy.ValueAxis.new(root, {
//         renderer: am5xy.AxisRendererY.new(root, {}),
//       })
//     );

//     const series = chart.series.push(
//       am5xy.CandlestickSeries.new(root, {
//         xAxis,
//         yAxis,
//         valueYField: "value",
//         openValueYField: "open",
//         lowValueYField: "low",
//         highValueYField: "high",
//         valueXField: "date",
//         tooltip: am5.Tooltip.new(root, {
//           labelText:
//             "Open: {openValueY}\nLow: {lowValueY}\nHigh: {highValueY}\nClose: {valueY}",
//         }),
//       })
//     );
//     seriesRef.current = series;
//     console.log(series, "series");

//     // Cursor
//     const cursor = chart.set(
//       "cursor",
//       am5xy.XYCursor.new(root, {
//         xAxis,
//       })
//     );
//     cursor.lineY.set("visible", false);

//     chart.appear(1000, 100);

//     // Update series data on data state change (live updates)
//     const dataDisposer = () => {
//       series.data.setAll(data);
//     };

//     dataDisposer();

//     return () => {
//       root.dispose();
//     };
//   }, []);

//   return <div ref={chartRef} style={{ width: "100%", height: "600px" }} />;
// };

// export default AmCandlestickChartReact;


// runningchart 
import React, { useLayoutEffect, useRef } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5stock from "@amcharts/amcharts5/stock";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

const StockChart = () => {
  const chartDiv = useRef(null);
  const root = useRef(null);
  const valueSeriesref= useRef()
  const websoketarrref = useRef([]);
  const dateAxisref =  useRef()
const API_KEY = process.env.REACT_APP_API_KEY;
  useLayoutEffect(() => {
    if (!chartDiv.current) return;

    // Create root element
    root.current = am5.Root.new(chartDiv.current);

    // Custom theme to hide minor and scrollbar grids
    const myTheme = am5.Theme.new(root.current);
    myTheme.rule("Grid", ["scrollbar", "minor"]).setAll({ visible: false });

    root.current.setThemes([am5themes_Animated.new(root.current), myTheme]);

    // Create stock chart
    const stockChart = root.current.container.children.push(
      am5stock.StockChart.new(root.current, {
        paddingRight: 0,
      })
    );

    // Set global number format
    root.current.numberFormatter.set("numberFormat", "#,###.00");

    // Create main panel
    const mainPanel = stockChart.panels.push(
      am5stock.StockPanel.new(root.current, {
        wheelY: "zoomX",
        panX: true,
        panY: true,
      })
    );

    // Value axis
    const valueAxis = mainPanel.yAxes.push(
      am5xy.ValueAxis.new(root.current, {
        renderer: am5xy.AxisRendererY.new(root.current, {
          pan: "zoom",
        }),
        extraMin: 0.1,
        tooltip: am5.Tooltip.new(root.current, {}),
        numberFormat: "#,###.00",
        extraTooltipPrecision: 2,
      })
    );
valueAxis.get("renderer").labels.template.setAll({
  fill: am5.color(0xffffff), // white labels
});
valueAxis.get("renderer").grid.template.setAll({
  stroke: am5.color(0xffffff), // white line
});
    // Date axis
    const dateAxis = mainPanel.xAxes.push(
      am5xy.GaplessDateAxis.new(root.current, {
        extraMax: 0.1,
        baseInterval: {
          timeUnit: "minute",
          count: 1,
        },
        renderer: am5xy.AxisRendererX.new(root.current, {
          pan: "zoom",
          minorGridEnabled: true,
           stroke: am5.color(0xffffff)
        }),
        tooltip: am5.Tooltip.new(root.current, {}),
      })
    );
dateAxisref.current  = dateAxis

dateAxis.get("renderer").labels.template.setAll({
  fill: am5.color(0xffffff),  // label color (yellow example)
});

dateAxis.get("renderer").grid.template.setAll({
  stroke: am5.color(0xffffff),  // grid line color (gray example)
  // strokeOpacity: 0.2,
})
    // Add range to show current value line and label
    const currentValueDataItem = valueAxis.createAxisRange(
      valueAxis.makeDataItem({ value: 0 })
    );
    const currentLabel = currentValueDataItem.get("label");
    if (currentLabel) {
      currentLabel.setAll({
        fill: am5.color(0xffffff),
        background: am5.Rectangle.new(root.current, { fill: am5.color(0x000000) }),
      });
    }
    const currentGrid = currentValueDataItem.get("grid");
    if (currentGrid) {
      currentGrid.setAll({ strokeOpacity: 0.5, strokeDasharray: [2, 5] });
    }

    // Add candlestick series
  valueSeriesref.current = mainPanel.series.push(
      am5xy.CandlestickSeries.new(root.current, {
        name: "BTC-USD",
        clustered: false,
        valueXField: "Date",
        valueYField: "Close",
        highValueYField: "High",
        lowValueYField: "Low",
        openValueYField: "Open",
        calculateAggregates: false,
        xAxis: dateAxis,
        yAxis: valueAxis,
        legendValueText:
          "open: [bold]{openValueY}[/] high: [bold]{highValueY}[/] low: [bold]{lowValueY}[/] close: [bold]{valueY}[/]",
        legendRangeValueText: "",
      })
    );

    stockChart.set("stockSeries",   valueSeriesref.current);

    // Add stock legend
    const valueLegend = mainPanel.plotContainer.children.push(
      am5stock.StockLegend.new(root.current, {
        stockChart: stockChart,
      })
    );
    valueLegend.data.setAll([valueSeriesref.current]);

    // Add cursor
    mainPanel.set(
      "cursor",
      am5xy.XYCursor.new(root.current, {
        yAxis: valueAxis,
        xAxis: dateAxis,
        snapToSeries: [valueSeriesref.current],
        snapToSeriesBy: "y!",
      })
    );

    // Add scrollbar
    // const scrollbar = mainPanel.set(
    //   "scrollbarX",
    //   am5xy.XYChartScrollbar.new(root.current, {
    //     orientation: "horizontal",
    //     height: 50,
    //   })
    // );
    // stockChart.toolsContainer.children.push(scrollbar);

    // const sbDateAxis = scrollbar.chart.xAxes.push(
    //   am5xy.GaplessDateAxis.new(root.current, {
    //     extraMax: 0.1,
    //     baseInterval: {
    //       timeUnit: "minute",
    //       count: 1,
    //     },
    //     renderer: am5xy.AxisRendererX.new(root.current, {
    //       minorGridEnabled: true,
    //     }),
    //   })
    // );

    // const sbValueAxis = scrollbar.chart.yAxes.push(
    //   am5xy.ValueAxis.new(root.current, {
    //     renderer: am5xy.AxisRendererY.new(root.current, {}),
    //   })
    // );

    // const sbSeries = scrollbar.chart.series.push(
    //   am5xy.LineSeries.new(root.current, {
    //     valueYField: "Close",
    //     valueXField: "Date",
    //     xAxis: sbDateAxis,
    //     yAxis: sbValueAxis,
    //   })
    // );

    // sbSeries.fills.template.setAll({
    //   visible: true,
    //   fillOpacity: 0.3,
    // });
  setTimeout(() => {
      const toolbar = am5stock.StockToolbar.new(root.current, {
        container: document.getElementById("chartcontrols"),
        stockChart: stockChart,
        controls: [am5stock.DrawingControl.new(root.current, { stockChart }),
           am5stock.IndicatorControl.new(root.current, { stockChart, indicatorTypes: ["MovingAverage", "RSI", "MACD"] })
        ]
      });
        const toolbarButtons = document.querySelectorAll("#chartcontrols button");
  toolbarButtons.forEach(button => {
    button.style.backgroundColor = "#ffff"; // Set your desired background color
    button.style.color = "#ffffff"; // Set your desired text color
    button.style.border = "1px solid #ffffff"; // Optional: set a border
  });
    }, 100);
    // Data generation
    let firstDate = new Date();
    let value = 1200;
    let lastDate;
   
    


    function generateChartData() {
      const chartData = [];

      for (let i = 0; i < 50; i++) {
        let newDate = new Date(firstDate);
        newDate.setMinutes(newDate.getMinutes() - i);

        value += Math.round((Math.random() < 0.49 ? 1 : -1) * Math.random() * 10);

        const open = value + Math.round(Math.random() * 16 - 8);
        const low = Math.min(value, open) - Math.round(Math.random() * 5);
        const high = Math.max(value, open) + Math.round(Math.random() * 5);

        chartData.unshift({
          Date: newDate.getTime(),
          Close: value,
          Open: open,
          Low: low,
          High: high,
        });

        lastDate = newDate;
      }
      return chartData;
    }

   fetchData();
// let chartData = generateChartData()
// console.log(chartData, "chartData")
    // sbSeries.data.setAll(data);
    //  valueSeriesref.current.data.setAll(chartData);
    // Live update interval
    const interval = setInterval(() => {
      const date = Date.now();
      const lastDataObject =   valueSeriesref.current.data.getIndex(valueSeriesref.current.data.length - 1);

      if (lastDataObject) {
        const previousDate = lastDataObject.Date;
        const previousValue = lastDataObject.Close;

        value = am5.math.round(previousValue + (Math.random() < 0.5 ? 1 : -1) * Math.random() * 2, 2);

        let high = lastDataObject.High;
        let low = lastDataObject.Low;
        let open = lastDataObject.Open;

        if (am5.time.checkChange(date, previousDate, "minute")) {
          open = value;
          high = value;
          low = value;

          const dObj1 = {
            Date: date,
            Close: value,
            Open: value,
            Low: value,
            High: value,
          };
console.log(dObj1, "alueSeriesref dObj1")
            valueSeriesref.current.data.push(dObj1);
          // sbSeries.data.push(dObj1);
        } else {
          if (value > high) {
            high = value;
          }
          if (value < low) {
            low = value;
          }

          const dObj2 = {
            Date: date,
            Close: value,
            Open: open,
            Low: low,
            High: high,
          };

            valueSeriesref.current.data.setIndex(valueSeriesref.current.data.length - 1, dObj2);
            console.log(dObj2, "alueSeriesref.current.data")
            // sbSeries.data.setIndex(sbSeries.data.length - 1, dObj2);
        }

        // Update current value label and background color
        if (currentLabel) {
          currentValueDataItem.animate({ key: "value", to: value, duration: 500, easing: am5.ease.out(am5.ease.cubic) });
          currentLabel.set("text", stockChart.getNumberFormatter().format(value));
          const bg = currentLabel.get("background");
          if (bg) {
            if (value < open) {
              bg.set("fill", root.current.interfaceColors.get("negative"));
            } else {
              bg.set("fill", root.current.interfaceColors.get("positive"));
            }
          }
        }
      }
 
    }, 1000);
    console.log(valueSeriesref.current.data._values, "valueSeriesref.current.data")
  // Zoom to the last N data points (e.g., last 50)
valueSeriesref.current.events.once("datavalidated", function () {
  const total = valueSeriesref.current.data.length;
  const startIndex = total > 50 ? total - 50 : 0;
  const start = valueSeriesref.current.data.getIndex(startIndex).Date;
  const end = valueSeriesref.current.data.getIndex(total - 1).Date;

  dateAxisref.current.zoomToDates(new Date(start), new Date(end));
});
const lastIndex = valueSeriesref.current.data.length - 1;
const lastDataPoint = valueSeriesref.current.data.getIndex(lastIndex);

if (lastDataPoint) {
  dateAxisref.current.zoomToDates(
    new Date(lastDataPoint.Date - 60_000 * 5), // Show 5 minutes window
    new Date(lastDataPoint.Date)
  );
}
 
    return () => {
      // clearInterval(interval);
      root.current.dispose();
    };
  }, []);
     const formatDate = (date) => {
    return date.toISOString().split("T")[0];
  };

const fetchData = async () => {
      const startDate = "2025-05-14";
      const currentTimestamp = Math.floor(Date.now() / 1000) * 1000;

      const url = `https://api.polygon.io/v2/aggs/ticker/X:BTCUSD/range/1/minute/${startDate}/${formatDate(
        new Date()
      )}?adjusted=true&apiKey=${API_KEY}`;

      try {
        const response = await fetch(url);
        const json = await response.json();

        if (json && json.results) {
          const chartData = json.results.map((item) => ({
            Date: item.t, // timestamp in ms
            Open: item.o,
            High: item.h,
            Low: item.l,
            Close: item.c, // close price
          }));
          // setData(chartData);
          // runwebsoket(chartData);

      valueSeriesref.current.data.setAll(chartData);
        if(valueSeriesref.current.data._values?.length){
   const totalDataCount = chartData.length;
const visibleCount = 15;
const startIndex = totalDataCount - visibleCount;
const endIndex = totalDataCount - 1;

  dateAxisref.current.zoomToIndexes(startIndex, endIndex);

  // dateAxisref.current.set("start", start);
  // dateAxisref.current.set("end", end);
    }
          // return chartData
        }
      } catch (error) {
        console.error("Error fetching Polygon data:", error);
      }
    };
     const runwebsoket = (data) => {
    if (data.length === 0) return;

    const socket = new WebSocket("wss://socket.polygon.io/crypto");
    // wsRef.current = socket;

    socket.onopen = () => {
      console.log("Polygon WebSocket connected");
      socket.send(`{"action":"auth","params":"${API_KEY}"}`);
      socket.send(`{"action":"subscribe","params":"XAS.BTC-USD@agg"}`); // subscribe to aggregate trades for BTCUSD
    };

    socket.onmessage = (event) => {
      const messages = JSON.parse(event.data);
      if (!Array.isArray(messages)) return;
      console.log(messages, "messages");
      messages.forEach((msg) => {
        if (msg.ev === "XAS") {
          // XA = Aggregate trades event
          // Polygon sends a new trade candle aggregate update

          const newCandle = {
            Date: msg.s,
            Open: msg.o,
            High: msg.h,
            Low: msg.l,
            Close: msg.c,
          };
             const lastDataObject =   valueSeriesref.current.data.getIndex(valueSeriesref.current.data.length - 1);
         
           const previousDate = lastDataObject.Date;
        const previousValue = lastDataObject.Close;
           if (am5.time.checkChange(newCandle?.Date, previousDate, "minute")) {
             const dObj1 = {
            Date: newCandle?.Date,
            Close: newCandle?.Close,
            Open: newCandle?.Close,
            Low: newCandle?.Close,
            High: newCandle?.Close,
          };
                  valueSeriesref.current.data.push(dObj1);
                  console.log(dObj1, "dObj1")
           }else{
             valueSeriesref.current.data.setIndex(valueSeriesref.current.data.length - 1, newCandle);
           console.log(newCandle, "dObj1 newCandle")
            }
            // let updateddata = updateDataWithWebSocketData(data, newCandle);
          // console.log(updateddata, "updateddata")
                // valueSeriesref.current.data.setAll(updateddata);
          // setData(updateddata);
          // setData((prevData) => {
          //   // Update existing candle if timestamp matches, else append
          //   const lastCandle = prevData[prevData.length - 1];
          //   if (lastCandle && lastCandle.date === newCandle.date) {
          //     // Replace last candle
          //     return [...prevData.slice(0, -1), newCandle];
          //   } else {
          //     return [...prevData, newCandle];
          //   }
          // });
        }
      });
    };

    socket.onerror = (err) => {
      console.error("WebSocket error:", err);
    };

    socket.onclose = () => {
      console.log("Polygon WebSocket disconnected");
    };

    return () => {
      socket.close();
    };
  };
   function updateDataWithWebSocketData(
  initialData,
  newData,
  interval = 1,
  unit = "minute"
) {
  const secondsTimestamp = Math.floor(newData.Date / 1000);
  const newTimestamp = Math.floor(secondsTimestamp / (interval * 60)) * interval * 60;
  const lastIndex = initialData.length - 1;
  const lastCandle = initialData[lastIndex];
  let updated = false;

  // Create a copy of the data array for immutability
  const updatedData = [...initialData];

  for (let i = 0; i < updatedData.length; i++) {
    if (updatedData[i].Date === newTimestamp * 1000) {
      websoketarrref.current.push({
        Close: newData.Close,
      });

      const highestHigh = Math.max(
        ...websoketarrref.current.map((item) => item.Close)
      );
      const lowestLow = Math.min(
        ...websoketarrref.current.map((item) => item.Close)
      );

      updatedData[i] = {
        ...updatedData[i],
        Close: newData.Close,
        High: highestHigh,
        Low: lowestLow,
        Date: newTimestamp * 1000,
      };
valueSeriesref.current.data.setIndex(  valueSeriesref.current.data.length - 1,   updatedData[i])
      updated = true;
      break;
    }
  }

  if (!updated) {
    websoketarrref.current = [];
    updatedData.push({
      Open: newData.Close,
      Close: newData.Close,
      High: newData.Close,
      Low: newData.Close,
      Date: newTimestamp * 1000,
    });
    valueSeriesref.current.data.push({
      Open: newData.Close,
      Close: newData.Close,
      High: newData.Close,
      Low: newData.Close,
      Date: newTimestamp * 1000,
    });
  }

  // Update chart series data directly
  // if (seriesRef.current) {
  //   seriesRef.current.data.setAll(updatedData);
  // }

  return updatedData;
}
//  const aroon = am5stock.Aroon.new(rootref.current, {
//       stockChart: stockChartref.current,
//       series: valueSeriesref.current,
//       period: 14  // optional: customize period
//     });
 return (
    <>
       <style>
        {`
          .am5stock-control-label {
            color: #fff
          }
        
        `}
      </style>
      <div id="chartcontrols" style={{ marginBottom: "10px" }}></div>
      <div id="chartdiv" ref={chartDiv} style={{ width: "100%", height: "600px", maxWidth: "100%" }}></div>
    </>
  );
};

export default StockChart;
// Am5CandlestickChart.jsx
// import React, { useLayoutEffect, useRef, useState } from "react";
// import * as am5 from "@amcharts/amcharts5";
// import * as am5xy from "@amcharts/amcharts5/xy";
// import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

// const LiveCandlestickChart = () => {
//   const chartDiv = useRef(null);

//   // Store buy/sell markers in a ref so updates don't trigger re-renders
//   const buySellMarkersRef = useRef([]);
//   const seriesRef = useRef(null);
//   const rootRef = useRef(null);
//   const [_, forceUpdate] = useState(0); // To force re-render for buttons if needed

//   useLayoutEffect(() => {
//     if (!chartDiv.current) return;

//     const root = am5.Root.new(chartDiv.current);
//     rootRef.current = root;

//     const myTheme = am5.Theme.new(root);
//     myTheme.rule("Grid", ["scrollbar", "minor"]).setAll({ visible: false });
//     root.setThemes([am5themes_Animated.new(root), myTheme]);

//     // ... generateChartData() and data as before
//     function generateChartData() {
//       const chartData = [];
//       let firstDate = new Date();
//       firstDate.setDate(firstDate.getDate() - 2000);
//       firstDate.setHours(0, 0, 0, 0);
//       let value = 1200;

//       for (let i = 0; i < 2000; i++) {
//         const newDate = new Date(firstDate);
//         newDate.setDate(newDate.getDate() + i);

//         value += Math.round((Math.random() < 0.5 ? 1 : -1) * Math.random() * 10);
//         const open = value + Math.round(Math.random() * 16 - 8);
//         const low = Math.min(value, open) - Math.round(Math.random() * 5);
//         const high = Math.max(value, open) + Math.round(Math.random() * 5);

//         chartData.push({
//           date: newDate.getTime(),
//           value,
//           open,
//           low,
//           high,
//         });
//       }
//       return chartData;
//     }

//     const data = generateChartData();

//     const chart = root.container.children.push(
//       am5xy.XYChart.new(root, {
//         focusable: true,
//         panX: true,
//         panY: true,
//         wheelX: "panX",
//         wheelY: "zoomX",
//         paddingLeft: 0,
//       })
//     );

//     const xAxis = chart.xAxes.push(
//       am5xy.DateAxis.new(root, {
//         groupData: true,
//         maxDeviation: 0.5,
//         baseInterval: { timeUnit: "day", count: 1 },
//         renderer: am5xy.AxisRendererX.new(root, {
//           pan: "zoom",
//           minorGridEnabled: true,
//         }),
//         tooltip: am5.Tooltip.new(root, {}),
//       })
//     );

//     const yAxis = chart.yAxes.push(
//       am5xy.ValueAxis.new(root, {
//         maxDeviation: 1,
//         renderer: am5xy.AxisRendererY.new(root, {
//           pan: "zoom",
//           opposite: true,
//         }),
//         inside: false,
//       })
//     );

//     const color = root.interfaceColors.get("background");

//     const series = chart.series.push(
//       am5xy.CandlestickSeries.new(root, {
//         fill: color,
//         calculateAggregates: true,
//         stroke: color,
//         name: "MDXI",
//         xAxis: xAxis,
//         yAxis: yAxis,
//         valueYField: "value",
//         openValueYField: "open",
//         lowValueYField: "low",
//         highValueYField: "high",
//         valueXField: "date",
//         lowValueYGrouped: "low",
//         highValueYGrouped: "high",
//         openValueYGrouped: "open",
//         valueYGrouped: "close",
//         legendValueText:
//           "open: {openValueY} low: {lowValueY} high: {highValueY} close: {valueY}",
//         legendRangeValueText: "{valueYClose}",
//         tooltip: am5.Tooltip.new(root, {
//           pointerOrientation: "horizontal",
//           labelText:
//             "open: {openValueY}\nlow: {lowValueY}\nhigh: {highValueY}\nclose: {valueY}",
//         }),
//       })
//     );

//     seriesRef.current = series;

//     const cursor = chart.set(
//       "cursor",
//       am5xy.XYCursor.new(root, {
//         xAxis: xAxis,
//       })
//     );
//     cursor.lineY.set("visible", false);

//     chart.leftAxesContainer.set("layout", root.verticalLayout);

//     const scrollbar = am5xy.XYChartScrollbar.new(root, {
//       orientation: "horizontal",
//       height: 50,
//     });
//     chart.set("scrollbarX", scrollbar);

//     const sbxAxis = scrollbar.chart.xAxes.push(
//       am5xy.DateAxis.new(root, {
//         groupData: true,
//         groupIntervals: [{ timeUnit: "week", count: 1 }],
//         baseInterval: { timeUnit: "day", count: 1 },
//         renderer: am5xy.AxisRendererX.new(root, {
//           minorGridEnabled: true,
//           strokeOpacity: 0,
//         }),
//       })
//     );

//     const sbyAxis = scrollbar.chart.yAxes.push(
//       am5xy.ValueAxis.new(root, {
//         renderer: am5xy.AxisRendererY.new(root, {}),
//       })
//     );

//     const sbseries = scrollbar.chart.series.push(
//       am5xy.LineSeries.new(root, {
//         xAxis: sbxAxis,
//         yAxis: sbyAxis,
//         valueYField: "value",
//         valueXField: "date",
//       })
//     );

//     const legend = yAxis.axisHeader.children.push(am5.Legend.new(root, {}));
//     legend.data.push(series);
//     legend.markers.template.setAll({ width: 10 });
//     legend.markerRectangles.template.setAll({
//       cornerRadiusTR: 0,
//       cornerRadiusBR: 0,
//       cornerRadiusTL: 0,
//       cornerRadiusBL: 0,
//     });

//     series.data.setAll(data);
//     sbseries.data.setAll(data);

//     // Live candle simulation (same as your code)
//     let candleInterval = 5000;
//     let currentCandle = { ...data[data.length - 1] };
//     let startTime = Date.now();

//     let updateInterval = setInterval(() => {
//       const now = Date.now();
//       const elapsed = now - startTime;

//       const lastIndex = series.data.length - 1;

//       const newPrice =
//         currentCandle.value +
//         Math.round((Math.random() < 0.5 ? -1 : 1) * Math.random() * 5);

//       currentCandle.high = Math.max(currentCandle.high, newPrice);
//       currentCandle.low = Math.min(currentCandle.low, newPrice);
//       currentCandle.value = newPrice;

//       series.data.setIndex(lastIndex, { ...currentCandle });
//       sbseries.data.setIndex(lastIndex, {
//         date: currentCandle.date,
//         value: currentCandle.value,
//       });

//       if (elapsed >= candleInterval) {
//         startTime = now;
//         const nextTime = currentCandle.date + candleInterval;

//         const open = currentCandle.value;
//         const value = open + Math.round((Math.random() < 0.5 ? -1 : 1) * Math.random() * 5);
//         const low = Math.min(open, value) - Math.round(Math.random() * 3);
//         const high = Math.max(open, value) + Math.round(Math.random() * 3);

//         currentCandle = {
//           date: nextTime,
//           open,
//           value,
//           low,
//           high,
//         };

//         series.data.push(currentCandle);
//         sbseries.data.push({ date: currentCandle.date, value: currentCandle.value });
//       }
//     }, 1000);

//     // Function to add a marker bullet at a given data item
//     function addMarker(type, dataItem) {
//       const color = type === "buy" ? am5.color(0x00ff00) : am5.color(0xff0000);
//       const labelText = type === "buy" ? "BUY" : "SELL";

//       // Create bullet on the series for the dataItem
//       const bullet = series.bullets.push(function () {
//         return am5.Bullet.new(root, {
//           sprite: am5.Label.new(root, {
//             text: labelText,
//             fill: color,
//             fontWeight: "bold",
//             background: am5.Rectangle.new(root, {
//               fill: color,
//               cornerRadiusTL: 5,
//               cornerRadiusTR: 5,
//               cornerRadiusBL: 5,
//               cornerRadiusBR: 5,
//             }),
//             paddingLeft: 5,
//             paddingRight: 5,
//           }),
//           locationX: 0.5,
//           locationY: 0,
//           // align label just above the candle
//           dy: -20,
//         });
//       });

//       // Link bullet to the data item
//       bullet.dataItem = dataItem;

//       buySellMarkersRef.current.push(bullet);
//     }

//     // Expose addMarker on rootRef for buttons
//     rootRef.current.addMarker = addMarker;
//     rootRef.current.getLatestDataItem = () => {
//       const lastIndex = series.data.length - 1;
//       return series.data.getIndex(lastIndex);
//     };

//     series.appear(1000);
//     chart.appear(1000, 100);

//     return () => {
//       clearInterval(updateInterval);
//       root.dispose();
//     };
//   }, []);

//   // Button handlers
//   const handleBuyClick = () => {
//     const root = rootRef.current;
//     if (!root) return;

//     const latestDataItem = root.getLatestDataItem();
//     if (!latestDataItem) return;

//     root.addMarker("buy", latestDataItem);
//   };

//   const handleSellClick = () => {
//     const root = rootRef.current;
//     if (!root) return;

//     const latestDataItem = root.getLatestDataItem();
//     if (!latestDataItem) return;

//     root.addMarker("sell", latestDataItem);
//   };

//   return (
//     <div>
//       <div style={{ marginBottom: 10 }}>
//         <button onClick={handleBuyClick} style={{ marginRight: 10 }}>
//           Buy
//         </button>
//         <button onClick={handleSellClick}>Sell</button>
//       </div>
//       <div
//         id="chartdiv"
//         ref={chartDiv}
//         style={{ width: "100%", height: "500px", border: "1px solid #ccc" }}
//       ></div>
//     </div>
//   );
// };

// export default LiveCandlestickChart;